import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';

export default class injectService {
    static injectStructuredData(dataForInject, scriptID) {
        if (dataForInject && scriptID) {
            const existingScript = document.getElementById(scriptID);
            if (!existingScript) {
                try {
                    const script = document.createElement('script');
                    script.type = 'application/ld+json';
                    script.id = scriptID;
                    script.innerHTML = JSON.stringify(dataForInject);
                    document.head.appendChild(script);
                } catch (err) {
                    reportError(err);
                }
            }
        } else {
            reportError(new Error('Ne postoji dataForInject ili scriptID u servisu "injectStructuredData"'));
        }
    }
}
